import { Box } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const PresenceSkeleton = () => {
  return (
    <Box className={styles['presence-skeleton__container']}>
      <SkeletonComponent height="26px" width="82px" mb="4px" />
      <SkeletonComponent height="18px" width="78px" mb="16px" />
      <SkeletonComponent height="132px" width="100%" />
    </Box>
  );
};

export default PresenceSkeleton;
